/**
 * KEYSTONE FIX — product option add-on price display
 *
 * Keystone Product Options captures the innermost text node of the product
 * price as the original amount. With superscript cents, `KM 47<sup>59</sup>`
 * is read as "59", so an add-on like [+KM 59,00] is written into the <sup>
 * instead of updating the full price (e.g. KM 106,59).
 *
 * snippets/block.product-price.liquid now outputs a single text node
 * ("KM 47,59"). This file copies that into a shadow root as
 * "KM 47<sup>59</sup>" so cents still look superscripted while Keystone
 * keeps reading and writing the full amount.
 *
 * To revert when Keystone is no longer used:
 * 1. In snippets/block.product-price.liquid, uncomment the Original
 *    element.price renders and comment out the KEYSTONE FIX ones
 * 2. Remove the keystone-price-compat.js <script> tag from
 *    snippets/block.product-price.liquid
 * 3. Delete this file
 */
(function () {
  if (window.__keystonePriceCompat) return
  window.__keystonePriceCompat = true

  var PRICE_ITEM_SELECTOR =
    'block-price .block-price__regular .element-price, block-price .block-price__sale .element-price'
  var WRITING = false

  function decimalSeparator(el) {
    var host = el && el.closest && el.closest('block-price')
    var sep = host && host.getAttribute('data-decimal-separator')
    return sep === ',' ? ',' : '.'
  }

  function flattenPriceItem(el) {
    if (!el || WRITING) return
    var sup = el.querySelector('sup')
    if (!sup) return

    var sep = decimalSeparator(el)
    var out = ''

    el.childNodes.forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        out += node.textContent
      } else if (node.nodeName === 'SUP') {
        var t = node.textContent.trim()
        // Keystone already dumped a full total into the cents node
        // ("KM 47<sup>106,59</sup>") — drop the leftover dollars and keep
        // that total. Otherwise "KM 47<sup>59</sup>" → "KM 47,59".
        if (/\d+[.,]\d+/.test(t)) {
          out = out.replace(/[\d.,]+$/, '') + t
        } else {
          out += sep + t
        }
      } else {
        out += node.textContent
      }
    })

    WRITING = true
    el.textContent = out
    WRITING = false
  }

  function formatCentsHtml(text, sep) {
    if (sep === ',') {
      return String(text).replace(/(\d[\d.]*)[,](\d+)/g, '$1<sup>$2</sup>')
    }
    return String(text).replace(/(\d[\d,]*)[.](\d+)/g, '$1<sup>$2</sup>')
  }

  function renderShadow(el) {
    var display = el.shadowRoot && el.shadowRoot.querySelector('[data-price-cents-display]')
    if (!display) return

    flattenPriceItem(el)
    var next = formatCentsHtml(el.textContent, decimalSeparator(el))
    if (display.innerHTML !== next) display.innerHTML = next
  }

  function attachPriceCentsShadow(el) {
    if (!el || el.nodeType !== 1) return
    if (el.shadowRoot) {
      renderShadow(el)
      return
    }

    flattenPriceItem(el)
    if (!el.textContent.trim()) return

    try {
      var shadow = el.attachShadow({ mode: 'open' })
      // Match original price CSS:
      // - snippets/style.normalize.liquid (sub/sup reset)
      // - snippets/element.price.liquid (.element-price sup)
      // - snippets/element.text.liquid (.element-text--line-through)
      shadow.innerHTML =
        '<style>' +
        ':host{' +
        '--_color-primary:var(--color-primary, inherit);' +
        'color:var(--_color-primary);' +
        '}' +
        '[data-price-cents-display]{' +
        'font:inherit;' +
        'color:inherit;' +
        'letter-spacing:inherit;' +
        'line-height:inherit;' +
        '-webkit-font-smoothing:antialiased;' +
        '}' +
        'sup{' +
        'font-size:75%;' +
        'line-height:0;' +
        'position:relative;' +
        'vertical-align:baseline;' +
        'top:-0.5em;' +
        '}' +
        'sup{' +
        'top:-0.5em;' +
        'font-size:60%;' +
        '}' +
        ':host(.element-text--line-through) [data-price-cents-display]{' +
        'text-decoration:line-through;' +
        '}' +
        '</style>' +
        '<span data-price-cents-display></span>'
    } catch (e) {
      return
    }

    renderShadow(el)
    new MutationObserver(function () {
      if (WRITING) return
      renderShadow(el)
    }).observe(el, {
      childList: true,
      characterData: true,
      subtree: true,
    })
  }

  function attachAll(root) {
    if (!root) return
    if (root.nodeType === 1 && root.matches && root.matches(PRICE_ITEM_SELECTOR)) {
      attachPriceCentsShadow(root)
    }
    if (root.querySelectorAll) {
      root.querySelectorAll(PRICE_ITEM_SELECTOR).forEach(attachPriceCentsShadow)
    }
  }

  attachAll(document)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) attachAll(node)
      })
    })
  }).observe(document.documentElement, { childList: true, subtree: true })
})()
